"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
const currencies_1 = require("../currencies");
class Taxes {
    constructor(id, name, country, state, currency, brokerServiceFeeLabel, brokerServiceFeeTaxable, taxes, notes, description, details, index, lastModifiedDate, lastModifiedBy, isApplicableToAllStates) {
        this.id = id;
        this.name = name;
        this.country = country;
        this.state = state;
        this.currency = currency;
        this.brokerServiceFeeLabel = brokerServiceFeeLabel;
        this.brokerServiceFeeTaxable = brokerServiceFeeTaxable;
        this.taxes = taxes;
        this.notes = notes;
        this.description = description;
        this.details = details;
        this.index = index;
        this.lastModifiedDate = lastModifiedDate;
        this.lastModifiedBy = lastModifiedBy;
        this.isApplicableToAllStates = isApplicableToAllStates;
        this.calculate = (currency, currencyConverter, premium, brokerServiceFees, otherTaxableFees = 0) => {
            const taxableFees = this.brokerServiceFeeTaxable
                ? otherTaxableFees + brokerServiceFees
                : otherTaxableFees;
            const taxCalcs = this.taxes
                .filter((tax) => tax.active)
                .map((tax) => ({
                currency,
                type: tax.type,
                name: tax.name,
                value: tax.calculate(currency, premium, taxableFees, currencyConverter),
                description: tax.description
            }));
            const taxTotal = taxCalcs
                .map((tax) => tax.value)
                .reduce((currentTotal, feeValue) => currentTotal + feeValue, 0);
            return {
                total: taxTotal,
                breakdown: taxCalcs
            };
        };
    }
    static fromObj(data) {
        var _a, _b;
        const currency = (_a = data.currency) !== null && _a !== void 0 ? _a : currencies_1.getCurrencyCodeByCountry(data.country);
        const taxes = data.taxes
            ? data.taxes.map((tax) => _1.taxComponentFromObj(Object.assign(Object.assign({}, tax), { currency })))
            : [];
        return new Taxes(data.id, data.name, data.country, data.state ? data.state : undefined, currency, data.brokerServiceFeeLabel, data.brokerServiceFeeTaxable, taxes, data.notes, data.description, data.details, data.index, data.lastModifiedDate, data.lastModifiedBy, (_b = data.isApplicableToAllStates) !== null && _b !== void 0 ? _b : false);
    }
    static empty() {
        return new Taxes("", "", "", "", "", "", false, []);
    }
}
exports.default = Taxes;
//# sourceMappingURL=taxes.class.js.map